// Import the web component for the burger icon/trigger
import "mburger-webcomponent";

// Module-level state for the mobile menu instance and API
let mobileMenu = null;
let api = null;
let initialized = false;

/**
 * Initializes the mobile menu.
 * - Parses server-provided HTML into DOM nodes
 * - Instantiates Mmenu with the parsed nodes and given options
 * - Sets up event listeners for toggling the menu and managing navigation
 */
function initMobileMenu() {
	// Prevent double initialization
	if (initialized) return;

	// Parse menu items HTML string into DOM nodes for Mmenu integration
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = bds_theme.features.mobile_menu.menu_items;
	const menuItems = Array.from(tempDiv.childNodes);

	// Create the Mmenu instance with options
	mobileMenu = new Mmenu(
		...menuItems,
		{
			...bds_theme.features.mobile_menu.mmenu_opts,
		},
		{
			offCanvas: {
				page: {
					selector: ".wp-site-blocks",
				},
			},
		},
	);

	// Reference the Mmenu API for later use
	api = mobileMenu.API;

	// Add event listener to handle burger icon clicks
	document.addEventListener("click", (event) => {
		const burger = event.target.closest("mm-burger");
		if (burger) {
			event.preventDefault();
			api?.open?.(); // Open the menu panel
		}
	});

	// Handle clicks on menu items with placeholder links (href="#")
	document.querySelectorAll(".mm-listitem__text").forEach((itemText) => {
		itemText.addEventListener("click", (event) => {
			const href = event.target.getAttribute("href");

			// If the link is a placeholder
			if (href && href.endsWith("#")) {
				const nextBtn = itemText.nextElementSibling;
				if (nextBtn?.classList.contains("mm-btn--next")) {
					const panelHref = nextBtn.getAttribute("href");

					// Use the Mmenu API to open the corresponding panel
					if (panelHref) {
						api?.openPanel?.(panelHref);
					}
				}
			}
		});
	});

	// Mark menu as initialized
	initialized = true;
}

/**
 * Destroys the mobile menu instance.
 * - Closes the menu if open
 * - Resets the initialized state
 * - Optionally calls the `destroy` method if provided by Mmenu
 */
function destroyMobileMenu() {
	// Only act if the menu is initialized
	if (!initialized) return;

	// Close the menu if the API provides a close method
	api?.close?.();

	// Call the destroy method on the Mmenu instance if it exists
	if (mobileMenu?.destroy instanceof Function) {
		mobileMenu.destroy();
	}

	// Reset state variables
	mobileMenu = null;
	api = null;
	initialized = false;
}

/**
 * Checks the viewport width and initializes or destroys the mobile menu as appropriate.
 * The mobile menu is active below the specified breakpoint.
 */
function checkMobileMenu() {
	const breakpoint = bds_theme?.features?.mobile_menu?.breakpoint || 782; // Default to 782px

	if (window.innerWidth < breakpoint) {
		initMobileMenu();
	} else {
		destroyMobileMenu();
	}
}

// Initialize and manage the mobile menu based on viewport and user actions
document.addEventListener("DOMContentLoaded", () => {
	// Initial check on DOM ready
	checkMobileMenu();

	// Re-check menu behavior on window resize
	window.addEventListener("resize", () => {
		checkMobileMenu();
	});
});
